import { render, staticRenderFns } from "./HomeNewsItem.vue?vue&type=template&id=72c83955&scoped=true&"
import script from "./HomeNewsItem.vue?vue&type=script&lang=js&"
export * from "./HomeNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewsItem.vue?vue&type=style&index=0&id=72c83955&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c83955",
  null
  
)

export default component.exports